import { FreshwatchAppMenuLinks } from '../../../../../customized/fresh-watch/components/App/header/AvatarMenu/AppMenuLinks/FreshwatchAppMenuLinks';
import { ToggleComponent } from '../../../../../featureToggle';
import { AppMenuLinks } from './AppMenuLinks';

export default ToggleComponent(AppMenuLinks, {
  styledComponentsVariants: {
    'fresh-watch': FreshwatchAppMenuLinks,
  },
});
